import React, { useEffect, useState } from 'react';
import { Table, Button, notification, Spin, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { getAccessTokenApi, logout } from '../../../../api/auth';
import Highlighter from 'react-highlight-words';

import { getSuppliersFinancialApi } from '../../../../api/financial';
import useUser from '../../../../hooks/useUser';
import { getAllSuppliers } from '../../../../api/supplier';
import { ROL_MANAGER } from '../../../../utils/constants';

export default function SuppliersTable() {
    const [reloadSuppliers, setReloadSuppliers] = useState(true);
    const [usersTable, setUsersTable] = useState([]);
    const [loadingForm, setLoadingForm] = useState(false);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const { person } = useUser();

    useEffect(() => {
        if (reloadSuppliers) {
            const token = getAccessTokenApi();

            if (person?.roles.includes(ROL_MANAGER)) {
                getAllSuppliers(token).then((response) => {
                    // console.log(response, 'suppliers');
                    if (response === undefined) {
                        notification['error']({
                            message: 'Ocurrió un error, Inténtelo más tarde',
                        });
                        return false;
                    }
                    if (response.statusCode === 200) {
                        response.result.forEach((element, index) => {
                            element['key'] = index;
                        });
                        setUsersTable(response.result);
                    } else {
                        notification['error']({
                            message: 'Usuario no autorizado',
                        });

                        setTimeout(() => {
                            logout();
                            window.location.reload();
                        }, 1500);
                        return;
                    }
                    setReloadSuppliers(false);
                });
            } else {
                getSuppliersFinancialApi(token, person.idUser).then(
                    (response) => {
                        if (response) {
                            if (response.statusCode === 401) {
                                notification['error']({
                                    message: 'Usuario no autorizado',
                                });

                                setTimeout(() => {
                                    logout();
                                    window.location.reload();
                                }, 1500);
                                return;
                            }
                            if (response.statusCode === 200) {
                                response.result.forEach((element, index) => {
                                    element['key'] = index;
                                });
                                setUsersTable(response.result);
                            }
                            setReloadSuppliers(false);
                        }
                    }
                );
            }
        }
    }, [reloadSuppliers, person]);

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        // this.searchInput = node;
                    }}
                    placeholder={`Buscar`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Limpiar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{ color: filtered ? '#1890ff' : undefined }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : '',
        filteredValue: filteredInfo[dataIndex] || null,
        onFilterDropdownVisibleChange: (visible) => {},
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: 'ID proveedor',
            ellipsis: true,
            dataIndex: 'supplierId',
            key: 'supplierId',
            ...getColumnSearchProps('supplierId'),
            render: (supplierId) => supplierId?.split('-')[0],
            width:150
        },
        {
            title: 'Nombre(s)',
            dataIndex: 'name',
            key: 'name',
            ...getColumnSearchProps('name'),
            ellipsis: true,
            width:150
        },
        {
            title: 'RFC',
            dataIndex: 'fiscalID',
            key: 'fiscalID',
            ...getColumnSearchProps('fiscalID'),
            ellipsis: true,
            width:150
        },
        {
            title: 'Teléfono',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            ...getColumnSearchProps('phoneNumber'),
            ellipsis: true,
            width:150
        },
        {
            title: 'Correo electrónico',
            dataIndex: 'emailAddress',
            key: 'emailAddress',
            ...getColumnSearchProps('emailAddress'),
            ellipsis: true,
            width:250

        },
    ];

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const handleChange = (pagination, filters, sorter, extra) => {
        setFilteredInfo(filters);
    };

    return (
        <>
            <Spin spinning={loadingForm} tip="Cargando...">
                <Table
                    onChange={handleChange}
                    columns={columns}
                    dataSource={usersTable}
                    scroll={{ x: 500 }}
                    loading={reloadSuppliers}
                    // pagination={{ defaultPageSize: 5 }}
                />
            </Spin>
        </>
    );
}
